module.exports = {"requests-path":"https://service-booking.jaguarlandrover.ru/"}


//////////////////
// WEBPACK FOOTER
// ./config/env.json
// module id = sT1v
// module chunks = 16